import ApiService from '@/services/api';

import { TDealType, TLicenseStatus } from '@/services/api/auth/get-user-info';

// TYPES

export type TGetLicenseOverviewMaterials = {
  companyId: number;
};

export type TLicenseOverviewResponse = {
  company_name: string;
  license_capacity: number;
  licenses_in_use: number;
  licenses_available: number;
  license_status: TLicenseStatus;
  /** ISO timestamp at which the licence expires or renews. */
  expire_date: string;
  /** Seats the base package already covers. */
  included_seats: number;
  /**
   * False while the company is still on its trial - and always false for an
   * individual agreement, which has no Stripe subscription to manage.
   */
  has_subscription: boolean;
  /** How the licence was sold. Decides whether anything may be bought here at all. */
  deal_type: TDealType;
  /** Whether the term extends by itself. False on an individual agreement: 'valid until', never 'renews on'. */
  auto_renews: boolean;
  /** The configured support address, for the individual-agreement notice. */
  support_email: string;
  /** The individual-agreement sentence, already filled in. Empty for a Stripe deal. */
  notice: string;
};

export const getLicenseOverview = async ({
  companyId,
}: TGetLicenseOverviewMaterials): Promise<TLicenseOverviewResponse> => {
  const response = await ApiService.get(`/v1/companies/${companyId}/licenses/`);
  return response?.data;
};
